import { Button, Icon } from 'loyal-react'
import { Link, withRouter } from 'react-router-dom'
import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'

const SendDocumentsBox = ({
  isHidden,
  hasFile,
  filesUpload,
  isLookingUpContact,
  handleDropFileFront,
  handleDropFileBack,
  handleUploadFile,
  error,
  location: { search }
}) => {
  return (
    <div id='box-login' className={`box-login box-send-documents row pb-4 ${isHidden && 'd-none'}`}>
      <div className='col-12 col-md-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3'>
        <div className='row'>
          <div className='col-12 mb-2'>
            <p className='txt-body-sm'>
              <a href={`/login${search}`} className='txt-body-sm d-block' aria-label='Voltar' role='button'>
                <Icon className='icon icon_left_app' />
              </a>
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>Envio de documentos</h1>
            <p className='txt-body-sm mb-1'>
              Para sua segurança, precisamos validar a sua autenticidade. Para isso precisamos que faça upload do seu
              <strong> RG</strong> ou
              <strong> CNH</strong> frente e verso.
            </p>
            <p className='txt-body-sm mb-1'>Os documentos podem ter no máximo 4Mb.</p>
            <div className='row mx-0 pt-2'>
              <Dropzone
                minSize={0}
                maxSize={4000000}
                multiple={false}
                accept='application/pdf, image/*'
                onDrop={handleDropFileFront}
              >
                {({ acceptedFiles, getRootProps, getInputProps, isDragActive, isDragReject }) => (
                  <div className='col-12'>
                    <input {...getInputProps()} />
                    <div
                      className={`cursor radius border-dashed border-dashed-lg  bg-ui-4 py-2 px-2 
                        ${!isDragActive && 'border-color-ui-3'} 
                        ${isDragActive && !isDragReject && 'border-color-success'} 
                        ${isDragReject && 'border-color-error'}`}
                      {...getRootProps()}
                    >
                      {acceptedFiles.length > 0 ? (
                        acceptedFiles.map((file) => (
                          <div className='row'>
                            <div className='col-auto'>
                              <div className='row align-items-center h-100'>
                                <div className='col-12'>
                                  {file.type === 'application/pdf' ? (
                                    <Icon iconName='icon_file' className='color-brand-1' />
                                  ) : (
                                    <Icon iconName='icon_picture' className='color-brand-1' />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='col'>
                              <p className='txt-opensans txt-body-sm pb-half'>Arquivo selecionado:</p>
                              <p className='txt-opensans txt-body-sm pb-half'>
                                <strong>{file.path}</strong>
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className='row'>
                          <div className='col-auto'>
                            <div className='row align-items-center h-100'>
                              <div className='col-12'>
                                <Icon iconName='icon_picture' className='color-brand-1' />
                              </div>
                            </div>
                          </div>
                          <div className='col'>
                            <p className='txt-opensans txt-body-sm pb-half'>
                              Selecione a <strong>frente do documento</strong>
                            </p>
                            <p className='txt-opensans txt-body-sm pb-half'>(JPG, PNG ou PDF).</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
            <div className='row mx-0 pt-2'>
              <Dropzone
                minSize={0}
                maxSize={4000000}
                multiple={false}
                accept='application/pdf, image/*'
                onDrop={handleDropFileBack}
              >
                {({ acceptedFiles, getRootProps, getInputProps, isDragActive, isDragReject }) => (
                  <div className='col-12'>
                    <input {...getInputProps()} />
                    <div
                      className={`cursor radius border-dashed border-dashed-lg  bg-ui-4 py-2 px-2 
                        ${!isDragActive && 'border-color-ui-3'} 
                        ${isDragActive && !isDragReject && 'border-color-success'} 
                        ${isDragReject && 'border-color-error'}`}
                      {...getRootProps()}
                    >
                      {acceptedFiles.length > 0 ? (
                        acceptedFiles.map((file) => (
                          <div className='row'>
                            <div className='col-auto'>
                              <div className='row align-items-center h-100'>
                                <div className='col-12'>
                                  {file.type === 'application/pdf' ? (
                                    <Icon iconName='icon_file' className='color-brand-1' />
                                  ) : (
                                    <Icon iconName='icon_picture' className='color-brand-1' />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='col'>
                              <p className='txt-opensans txt-body-sm pb-half'>Arquivo selecionado:</p>
                              <p className='txt-opensans txt-body-sm pb-half'>
                                <strong>{file.path}</strong>
                              </p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className='row'>
                          <div className='col-auto'>
                            <div className='row align-items-center h-100'>
                              <div className='col-12'>
                                <Icon iconName='icon_picture' className='color-brand-1' />
                              </div>
                            </div>
                          </div>
                          <div className='col'>
                            <p className='txt-opensans txt-body-sm pb-half'>
                              Selecione o <strong>verso do documento</strong>
                            </p>
                            <p className='txt-opensans txt-body-sm pb-half'>(JPG, PNG ou PDF).</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
          </div>
        </div>
        {error ? (
          <div className='col-12 col-md-12 mr-auto mt-2'>
            <div className='row'>
              <span className='message message-error' role='alert'>
                <small className='txt-subtitle txt-opensans color-error'>{error ? error.message : ''}</small>
              </span>
            </div>
          </div>
        ) : (
          ''
        )}
        <div className='col-12 col-md-12 txt-center mt-2 px-0'>
          <div className='hide-absolute' aria-live='assertive' role='status' aria-atomic='true'>
            {!hasFile && 'Por favor, informe seu celular'}
          </div>
          <Button
            id='btnSend-documents'
            className='btn btn-sm btn-featured'
            type='button'
            text='Enviar'
            disabled={!hasFile}
            loading={isLookingUpContact}
            onClick={handleUploadFile}
          />
        </div>
      </div>
    </div>
  )
}

SendDocumentsBox.propTypes = {
  isHidden: PropTypes.bool,
  hasFile: PropTypes.bool,
  filesUpload: PropTypes.object,
  isLookingUpContact: PropTypes.bool,
  handleDropFileFront: PropTypes.func,
  handleDropFileBack: PropTypes.func,
  handleUploadFile: PropTypes.func,
  error: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default withRouter(SendDocumentsBox)
